import styled from "styled-components"

const GuildDetailContainer = styled.div`
    width: 100%;
`

export default GuildDetailContainer